import React, { useEffect, useRef, useState } from "react"
import { Link, useLocation, useNavigate } from "react-router-dom"
import { useAuth } from "../hooks/useAuth"
import "./TopMenu.css"

const NAV_LINKS = [
  { to: "/home", label: "Home" },
  { to: "/map", label: "Map" },
  { to: "/about", label: "About" },
  { to: "/who-we-are", label: "Who We Are" },
  { to: "/who-we-serve", label: "Who We Serve" },
  { to: "/coverage", label: "Coverage" },
  { to: "/contact", label: "Contact Us" },
  { to: "/faq", label: "FAQ" },
]

const isNavLinkActive = (pathname, to) => {
  if (to === "/map") {
    return pathname === "/" || pathname === "/map" || pathname.startsWith("/country/")
  }
  return pathname === to
}

const TopMenu = () => {
  const { user, logout } = useAuth()
  const location = useLocation()
  const navigate = useNavigate()

  const [navOpen, setNavOpen] = useState(false)
  const [profileOpen, setProfileOpen] = useState(false)
  const profileRef = useRef(null)

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (profileRef.current && !profileRef.current.contains(e.target)) {
        setProfileOpen(false)
      }
    }
    document.addEventListener("mousedown", handleClickOutside)
    return () => document.removeEventListener("mousedown", handleClickOutside)
  }, [])

  // Close any open menu on navigation.
  useEffect(() => {
    setNavOpen(false)
    setProfileOpen(false)
  }, [location.pathname])

  const handleLogout = async () => {
    setProfileOpen(false)
    await logout()
    navigate("/login")
  }

  return (
    <header className="epw-site-header">
      <Link className="epw-site-logo" to="/home" aria-label="EnergyPulseWorld Home">
        <img src="/logo.png" alt="EnergyPulseWorld" />
      </Link>

      <nav className={`epw-main-nav${navOpen ? " is-open" : ""}`} aria-label="Primary navigation">
        {NAV_LINKS.map((link) => (
          <Link
            key={link.to}
            to={link.to}
            aria-current={isNavLinkActive(location.pathname, link.to) ? "page" : undefined}
            onClick={() => setNavOpen(false)}
          >
            {link.label}
          </Link>
        ))}
      </nav>

      <div className="epw-profile">
        <button
          className="epw-nav-toggle"
          type="button"
          aria-label="Open navigation"
          aria-expanded={navOpen}
          onClick={() => setNavOpen((prev) => !prev)}
        >
          <span></span><span></span><span></span>
        </button>

        {user ? (
          <div className="epw-account" ref={profileRef}>
            <button
              type="button"
              className="epw-profile-link epw-account-btn"
              onClick={() => setProfileOpen((prev) => !prev)}
              aria-expanded={profileOpen}
              aria-haspopup="true"
            >
              <span>{user.username}</span>
              <span className="epw-profile-icon" aria-hidden="true"></span>
            </button>

            {profileOpen && (
              <div className="epw-account-dropdown">
                <button
                  type="button"
                  className="epw-account-dropdown-item"
                  onClick={() => {
                    setProfileOpen(false)
                    navigate("/profile")
                  }}
                >
                  Profile
                </button>

                <button
                  type="button"
                  className="epw-account-dropdown-item"
                  onClick={handleLogout}
                >
                  Logout
                </button>
              </div>
            )}
          </div>
        ) : (
          <Link className="epw-profile-link" to="/login" aria-label="Profile / Login">
            <span>Profile</span>
            <span className="epw-profile-icon" aria-hidden="true"></span>
          </Link>
        )}
      </div>
    </header>
  )
}

export default TopMenu
